(function () {
  if (window.productVideoUpsellBound) return;
  window.productVideoUpsellBound = true;

  const rootSelector = 'product-video-upsell';
  const modalOpenClass = 'product-video-upsell-modal-open';

  function getRoot(target) {
    return target.closest(rootSelector);
  }

  function getModal(root) {
    return root?.querySelector('[data-upsell-modal]');
  }

  function getModalVideo(root) {
    return root?.querySelector('.product-video-upsell__modal-video');
  }

  function closeModal(root) {
    const modal = getModal(root);
    const modalVideo = getModalVideo(root);

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-modal-open');
    document.body.classList.remove(modalOpenClass);

    if (modalVideo) {
      modalVideo.pause();
      modalVideo.currentTime = 0;
    }
  }

  function openModal(root) {
    const modal = getModal(root);
    const modalVideo = getModalVideo(root);

    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    root.classList.add('is-modal-open');
    document.body.classList.add(modalOpenClass);

    if (modalVideo) {
      modalVideo.currentTime = 0;
      modalVideo.muted = false;
      modalVideo.volume = 1;

      const playPromise = modalVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    root.querySelector('.product-video-upsell__modal-close')?.focus();
  }

  document.addEventListener('click', (event) => {
    const closeBubbleButton = event.target.closest('[data-upsell-close]');
    if (closeBubbleButton) {
      const root = getRoot(closeBubbleButton);
      if (!root) return;

      event.preventDefault();
      event.stopPropagation();
      root.remove();
      return;
    }

    const modalCloseButton = event.target.closest('[data-upsell-modal-close]');
    if (modalCloseButton) {
      const root = getRoot(modalCloseButton);
      if (!root) return;

      event.preventDefault();
      closeModal(root);
      return;
    }

    const openButton = event.target.closest('[data-upsell-open]');
    if (openButton) {
      const root = getRoot(openButton);
      if (!root) return;

      event.preventDefault();
      openModal(root);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(`${rootSelector}.is-modal-open`).forEach((root) => {
      closeModal(root);
    });
  });
})();
